import { gql } from '@apollo/client';

export const UPDATE_USER_PREFERENCES_MUTATION = gql`
    mutation updateUserPreferences($input: UpdateUserPreferences!) {
        updateUserPreferences(input: $input) {
            theme
            landingPage
            navCollapsed
        }
    }
`;
